import { Button } from '@astryxdesign/core/Button';
import { Card } from '@astryxdesign/core/Card';
import { HStack } from '@astryxdesign/core/HStack';
import { Link } from '@astryxdesign/core/Link';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { ChatCircleDots } from '@phosphor-icons/react';
import { useNavigate } from 'react-router';
import { Reveal } from '@/components/Reveal';
import { useBookingFlow } from '@/features/booking/useBookingFlow';
import { useStudioData } from '@/features/studio/StudioContext';
import { BookingCard } from './BookingCard';
import { Contacts } from './Contacts';
import { Gallery } from './Gallery';
import { Hero } from './Hero';
import { InfoCards } from './InfoCards';

export const ASSISTANT_EXAMPLES = ['Когда ближайшее окно?', 'Сколько стоит полировка?', 'Как найти студию?'];

export function HomePage() {
  const studio = useStudioData();
  const flow = useBookingFlow();
  const navigate = useNavigate();

  return (
    <>
      <Hero studio={studio} onBook={() => flow.open()} />
      <VStack gap={8} paddingInline={4} paddingBlock={6} className="page-column">
        {studio.settings.description && (
          <Reveal>
            <Text textWrap="pretty">{studio.settings.description}</Text>
          </Reveal>
        )}
        <Reveal>
          <BookingCard studio={studio} onBook={(id) => flow.open(id)} />
        </Reveal>
        <Reveal label="Почему мы">
          <InfoCards cards={studio.infoCards} />
        </Reveal>
        <Reveal>
          <Gallery items={studio.gallery} />
        </Reveal>
        <Reveal label="Помощник">
          <Card variant="muted">
            <VStack gap={3}>
              <HStack gap={2} vAlign="center">
                <ChatCircleDots size={24} className="text-accent" aria-hidden />
                <Text weight="semibold">Спросите помощника</Text>
              </HStack>
              <Text color="secondary">Подберёт свободное окно, подскажет цену и дорогу.</Text>
              <HStack gap={2} wrap="wrap">
                {ASSISTANT_EXAMPLES.map((q) => (
                  <Button key={q} label={q} size="sm" onClick={() => navigate(`/s/${studio.slug}/assistant?q=${encodeURIComponent(q)}`)} />
                ))}
              </HStack>
            </VStack>
          </Card>
        </Reveal>
        <Reveal>
          <Contacts studio={studio} />
        </Reveal>
        <HStack gap={4} justify="between" as="footer">
          <Text type="supporting">© {studio.settings.name}</Text>
          <Link href={`/s/${studio.slug}/owner/`} color="secondary">
            Кабинет владельца
          </Link>
        </HStack>
      </VStack>
    </>
  );
}
